import { useQueries, UseQueryResult } from "@tanstack/react-query";
import { getImageFile } from "shared/api/firebase/getImageFile";
import { queryClient } from "shared/api/queryClient";

type ImageFileProps = {
  queries: {
    queryKey: string[];
    path: string | undefined | null;
    setImageFile?: (file: File | null) => void;
  }[];
  enabled: boolean;
};

export const useImageFilesQueries = ({
  queries = [],
  enabled,
}: ImageFileProps): UseQueryResult<File | undefined>[] => {
  return useQueries({
    queries: queries.map(({ queryKey, path, setImageFile }) => ({
      queryKey,
      queryFn: async () => {
        if (path) {
          const file = await getImageFile(path);

          if (file) {
            setImageFile?.(file);
          }

          return file;
        }
      },
      enabled: Boolean(enabled) && Boolean(path),
      staleTime: 0,
    })),
  });
};

export const invalidateImageFilesQueries = async (queryKeys: string[][]) => {
  for (const queryKey of queryKeys) {
    await queryClient.invalidateQueries({ queryKey });
  }
};
